<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Organization</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <!--v-show="!isEdit"-->
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="textSearch"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Organization
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="OrgName"
                v-model="selectedObj.Name"
                :rules="organizationRules"
                label="Organization Name *"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="description"
                v-model="selectedObj.Description"
                label="Description"
                required
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                id="Country"
                v-model="selectedObj.country"
                :items="countries"
                label="Country"
                item-text="CountryName"
                item-value="id"
                return-object
              ></v-select>
            </div>
            <div class="col">
              <v-text-field
                id="userLimit"
                v-model="selectedObj.UserLimit"
                :rules="userLimitRules"
                label="User Limit *"
                required
                type="number"
              ></v-text-field>
            </div>
          </div>
          <v-divider></v-divider>
          <h4 class="pt-5">Configurations</h4>
          <br>
          <div class="row">
            <div class="col">
              <v-text-field
                id="lendingDuration"
                v-model="selectedObj.LendingDuration"
                :rules="LendingDurationRules"
                label="Lending Duration"
                required
                type="number"
              ></v-text-field>
            </div>
            <div class="col">
             
            </div>
          </div>
          <v-divider  class="pt-5"></v-divider>
          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
        <ConfirmationDialog ref="confirm" />
      </div>
      <!--
      <div v-show="isEdit && this.selectedObj.id > 0">   
        <v-tabs v-model="tab">
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">          
          <v-tab-item ><PurchasedCollections :organization="selectedObj"/></v-tab-item>
        </v-tabs-items>
      </div>
      -->
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Organization Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Country</th>
                  <th class="text-left" style="width: 125px">User Limit</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <td>
                    {{ item.country != null ? item.country.CountryName : "" }}
                  </td>
                  <!---->
                  <td>{{ item.UserLimit }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import PurchasedCollections from "@/components/PurchasedCollections";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import * as api from "@/api";
export default {
  name: "Organization",
  components: {
    Notification,
    Pagination,
    PurchasedCollections,
    ConfirmationDialog
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  created() {
    this.getCountries();
    this.getOrganizationByPagin();
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
    getOrganizationByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization", this.paging)
          .then((response) => {
            that.overlay = false
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.Name = "";
      this.Description = "";
      this.UserLimit = 0;
      this.LicenseLimit = 0;
      this.LendingDuration = 14;
      this.valid = false;
      this.selectedObj.id = 0;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid) return;
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("organization", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              if (that.id == 0) {
                this.notify.message = "Record successfully created.";
              } else {
                this.notify.message = "Record successfully updated.";
              }
              this.getOrganizationByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
            that.overlay = false
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Organization name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            }
            that.overlay = false
          });
      });

      this.isEdit = false;
      this.$refs.form.reset();
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getOrganization();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
    },
    getOrganization() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCountries() {
      this.countries = [];
      new Promise((resolve, reject) => {
        api
          .getAll("country")
          .then((response) => {
            console.log(response.data);
            this.countries = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        Name: "",
        Description: "",
        UserLimit: 0,
        LicenseLimit: 0,
        LendingDuration: 14
      },
      //form: Object.assign({}, defaultForm),
      id: 0,
      Name: "",
      Description: "",
      UserLimit: 0,
      LicenseLimit: 0,
      LendingDuration: 14,
      organizationRules: [(v) => !!v || "Organization Name is required"],
      userLimitRules: [(v) => !!v || "User Limit is required", v => (v && parseInt(v) > 0) || 'User Limit should be greator than zero'],
      licenseLimitRules: [(v) => !!v || "License Limit is required"],
      LendingDurationRules: [(v) => !!v || "Lending duration is required" , v => (v && parseInt(v) > 0) || 'Lending duration should be greator than zero'],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      tab: null,
      items: ["Assign BiblioTech collections"], // "Licenses", "Collections",
      overlay : false
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Organization.vue